<template>
    <button class="btn big-btn" @click="$emit('sort')">Play New Game</button>
</template>

<script>
export default {
    data() {
        return{}
    },
    emits: ['sort'],
    methods: {
        sendData() {
            this.$emit('sort')
        }
    }
}
</script>

<style scoped>
.btn {
  background: rgb(240, 240, 240);
  width: 100%;
  border: 0;
  min-height: 8rem;
  padding: 1rem;
  border-radius: 1rem;
  text-align: center;
  margin: 1rem 0 4rem 0;
}

.btn:hover {
  background: rgb(196, 196, 196);
}

.btn:active {
  background: rgb(255, 227, 150);
}

.big-btn {
  font-size: 2.5rem;
}

</style>